import { useContextState } from "../../../hooks/theme"

const useSelectDataToAssignStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            width: '100%',
            display: "flex",
            flexWrap: 'wrap',
            padding: '0px 2px',
            gap: '30px',
            '& .gap-10': {
                gap: '10px'
            },
            '& .w-full': {
                width: '100%',
            },
            '& .bold': {
                fontSize: '26px'
            },
            '& .success-store': {
                fontSize: '14px',
                color: colors.color8
            },
            '& .error-store': {
                fontSize: '14px',
                color: colors.color19
            },
            '& .btn-black': {
                background: colors.color22,
                '&:hover': {
                    background: `${colors.color22}dd`,
                },
                padding: '5px 20px'
            },
            '& .btn-purple': {
                background: colors.primary,
                '&:hover': {
                    background: `${colors.primary}dd`,
                },
                padding: '5px 20px'
            },
            '& .separator-r': {
                borderRight: `2px solid ${colors.greyClear}`,
                width: '1px',
                height: '20px'
            },
            '& .flex-start': {
                alignItems: 'start'
            }
        },
        containerFlex: {
            display: "flex",
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0px 5px',
            '&.padding-5': {
                padding: '5px'
            },
            '&.gap-5': {
                gap: '5px'
            }
        },
        title: {
            fontSize: '18px',
            color: colors.color10,
            fontWeight: 'bold'
        },
        text: {
            fontSize: '14px',
            color: colors.color10,
        },
        description: {
            fontSize: '14px',
            color: colors.color10,
            maxWidth: '600px',
            textAlign: 'end'
        },
        warningBg: {
            background: `${colors.color12}30`,
        }
    }
}

export { useSelectDataToAssignStyles }
